import script from "./bcParse.vue?vue&type=script&setup=true&lang=js"
export * from "./bcParse.vue?vue&type=script&setup=true&lang=js"

import "./bcParse.vue?vue&type=style&index=0&id=0126d6d4&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0126d6d4"]])

export default __exports__